// extracted by mini-css-extract-plugin
module.exports = {"container":"container__V6_Wr","embedded":"embedded__UVH04","interactive":"interactive__2OOiD","title":"title__3NrAd"};